import {
	BonusMarketplaceDetailsREST,
	UserBonusMarketplaceResultREST,
} from "@api-types/my-bonuses/MarketplaceBonus";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class MarketplaceBonusEligibilityApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/user-marketplace-bonus-eligibility`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};
	static async useMarketplaceBonus(
		isBonusDeclined: boolean,
		options: ContextOptions
	): Promise<UserBonusMarketplaceResultREST> {
		const context = getApiRequestContext(options);
		const marketplaceBonusDetails: BonusMarketplaceDetailsREST = {
			userBettingAccountTypeId: context.accountTypeId || "",
			isBonusDeclined: isBonusDeclined,
		};

		return await httpClient.put(
			`${this.baseUrl}/use-marketplace-bonus/${context.agencyId}/${context.userId}`,
			JSON.stringify(marketplaceBonusDetails),
			this.getRequestHeaders(context)
		);
	}
}
